import { render, staticRenderFns } from "./EditEstadocivilPage.vue?vue&type=template&id=b1345b16&"
import script from "./EditEstadocivilPage.vue?vue&type=script&lang=js&"
export * from "./EditEstadocivilPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports